import { useParams } from 'react-router-dom';
import React, { useState, useEffect,useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import Form from "react-bootstrap/Form";
import { ROUTES, USER_ROLES, USERS_ROLE, HANGUP_CAUSES, BACKEND_API_BASE_URL } from "../../../utilities/constant";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { API_INCOMING_SUMMARY_LIST, DOWNLOAD_REPORT, API_INCOMING_REPORT_BY_DID_LIST, API_HANGUP_CAUSES } from '../../../service/url';
import { getApiCall } from '../../../service/getApiCall';
// import { formatDateTime } from '../../../utilities/helpers';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { PhoneIncoming, PhoneOutgoing } from "lucide-react";
import '../../../assets/custom/css/tabs.css'

import { FaInfoCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import {
  loadPortalReportData,
  PORTAL_REPORT_RESOURCES,
} from "../../../utilities/portalReportRefresh";
import { Storage } from "../../../utilities/setting";

export const getRecordingData = (recordingFile) => {
  try {
    if (!recordingFile) return [];

    const recordings =
      typeof recordingFile === "string"
        ? JSON.parse(recordingFile)
        : recordingFile;

    const baseUrl = BACKEND_API_BASE_URL.replace("/api", "");

    return recordings.map((rec) => {
      const folder =
        rec.type?.toLowerCase() === "voicemail"
          ? "voicemail"
          : "recordings";

      return {
        ...rec,
        url: `${baseUrl}/recordings/${folder}/${rec.name}`,
      };
    });
  } catch (err) {
    console.log("Recording parse error:", err);
    return [];
  }
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "-";

  try {
    let date;
    if (
      typeof dateString === "string" &&
      dateString.includes(" ") &&
      !dateString.includes("T")
    ) {
      const isoString = dateString.replace(" ", "T") + "Z";
      date = new Date(isoString);
    } else {
      date = new Date(dateString);
    }

    if (isNaN(date.getTime())) return "-";

    return date.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour12: false,
    });
  } catch (err) {
    console.error("Date format error:", err);
    return "-";
  }
};


const dateToInputStr = (d) => {
  if (!d) return "";
  const dt = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) return "";
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const day = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const timeToInputStr = (d) => {
  if (!d) return "";
  const dt = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) return "";
  const h = String(dt.getHours()).padStart(2, "0");
  const m = String(dt.getMinutes()).padStart(2, "0");
  return `${h}:${m}`;
};

const inputStrToTimeDate = (str) => {
  if (!str) return null;
  const [h, m] = str.split(":").map((v) => parseInt(v, 10));
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  const d = new Date();
  d.setHours(h, m, 0, 0);
  return d;
};

const DidDetailPage = () => {
  const [hangupCauseMap, setHangupCauseMap] = useState({});

  const audioRefs = useRef({});
  const toNum = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const isConnected = (call) => toNum(call?.billing_duration) > 0;
  const hasRung = (call) => (toNum(call?.bridge_ring_duration) > 0) || (toNum(call?.ring_duration) > 0);

  const statusStyles = {
    success: {
      backgroundColor: "rgba(0, 128, 0, 0.7)",
      color: "#ffffff",
      width: "85px",
      padding: "4px 10px",
      borderRadius: "4px",
      textAlign: "center",
      margin: 0
    },
    failed: {
      backgroundColor: "rgba(255, 0, 0, 0.7)",
      color: "#ffffff",
      width: "75px",
      padding: "4px 10px",
      borderRadius: "4px",
      textAlign: "center",
      margin: 0
    }
  };

  // Decide Success/Failed from billable duration.
  // Requirement: if `billing_duration > 0` then always show "Success".
  const isSuccessByBillingDuration = (row) =>
    Number(row?.billing_duration || 0) > 0;
  const { did, startDate, endDate } = useParams();
  const [incomingReport, setIncomingReport] = useState([]);
  const [detailStartDate, setDetailStartDate] = useState(startDate);
  const [detailEndDate, setDetailEndDate] = useState(endDate);
  const [detailStartTime, setDetailStartTime] = useState(() => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  });
  const [detailEndTime, setDetailEndTime] = useState(() => {
    const date = new Date();
    date.setHours(23, 59, 0, 0);
    return date;
  });

  const [playingId, setPlayingId] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loggedInUserId, setLoggedInUserId] = useState(null);

  const [selectedCall, setSelectedCall] = useState([]);
  const [showSidePanel, setShowSidePanel] = useState(false);
  const [statusDialogVisible, setStatusDialogVisible] = useState(false);
  const [statusDialogCall, setStatusDialogCall] = useState(null);



  const [mainCall, setMainCall] = useState(null); // for clicked one
  const [relatedCalls, setRelatedCalls] = useState([]); // others with same trace_id


  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      const rawUser = Storage.getItem('user');
      if (!rawUser) {
        console.error("User data not found in Storage");
        return;
      }
      let user;
      try {
        user = JSON.parse(rawUser);
      } catch (e) {
        console.error("Invalid JSON in Storage user:", e);
        return;
      }
      setUserRole(user?.role);
      setLoggedInUserId(user?.id);
    };
    fetchUserData()
  }, [])


  const fetchIncomingReport = async (start, end, startTime, endTime, force = false) => {
    if (!loggedInUserId || !userRole) {
      return;
    }

    const startMoment = moment(start);
    const endMoment = moment(end);

    const startTimeMoment = moment(startTime);
    const endTimeMoment = moment(endTime);

    const formattedStart = startMoment
      .hour(startTimeMoment.hour())
      .minute(startTimeMoment.minute())
      .second(0)
      .format("YYYY-MM-DD HH:mm:ss");

    const formattedEnd = endMoment
      .hour(endTimeMoment.hour())
      .minute(endTimeMoment.minute())
      .second(59)
      .format("YYYY-MM-DD HH:mm:ss");

    try {
      const result = await loadPortalReportData({
        resource: PORTAL_REPORT_RESOURCES.INCOMING_REPORT_BY_DID,
        userId: loggedInUserId,
        role: userRole,
        params: { did, startDate: formattedStart, endDate: formattedEnd },
        force,
        onBlocked: (remainingMs) => {
          toast.info(
            `Incoming report can be refreshed after ${Math.ceil(remainingMs / 1000)} seconds.`
          );
        },
        fetchFn: () =>
          getApiCall(
            `${API_INCOMING_REPORT_BY_DID_LIST}/${did}/${formattedStart}/${formattedEnd}`
          ),
      });
      setIncomingReport(result.data || []);
    } catch (err) {
      console.log(err);
    }
  };



  useEffect(() => {
    if (!loggedInUserId || !userRole) {
      return;
    }

    fetchIncomingReport(
      detailStartDate,
      detailEndDate,
      detailStartTime,
      detailEndTime,
      false
    );
  }, [
    did,
    detailStartDate,
    detailEndDate,
    detailStartTime,
    detailEndTime,
    loggedInUserId,
    userRole,
  ]);

  const handleDetailFilter = () => {
    fetchIncomingReport(
      detailStartDate,
      detailEndDate,
      detailStartTime,
      detailEndTime,
      true
    );
  };

  const handleDetailClearFilter = () => {
    setDetailStartDate(startDate);
    setDetailEndDate(endDate);
    const resetStart = new Date();
    resetStart.setHours(0, 0, 0, 0);
    const resetEnd = new Date();
    resetEnd.setHours(23, 59, 0, 0);
    setDetailStartTime(resetStart);
    setDetailEndTime(resetEnd);
    fetchIncomingReport(startDate, endDate, resetStart, resetEnd, true);
  };

  const handlePlayPause = (id) => {
  const current = audioRefs.current[id];

  if (playingId && playingId !== id) {
    audioRefs.current[playingId]?.pause();
    audioRefs.current[playingId].currentTime = 0;
  }

  if (playingId === id) {
    current.pause();
    setPlayingId(null);
  } else {
    current.play();
    setPlayingId(id);
  }
};

  const openStatusDialog = (call) => {
    setStatusDialogCall(call);
    setStatusDialogVisible(true);
  };

  const statusPill = (call) => {
    const connected = isConnected(call);
    const style = connected ? statusStyles.success : statusStyles.failed;

    return (
      <div
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          cursor: "default",
          userSelect: "none",
          border: "1px solid rgba(0,0,0,0.06)",
          width: "100%",
          // color: "white",
        }}
      >
        <span style={{ fontWeight: 600 }}>
          {connected ? "Connected" : "Failed"}
        </span>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            openStatusDialog(call);
          }}
          style={{
            border: "none",
            background: "transparent",
            padding: 0,
            margin: 0,
            lineHeight: 1,
            cursor: "pointer",
            color: connected ? "#006400" : "#b00000",
          }}
          aria-label="View call events"
          title="View call events"
        >
          <FaInfoCircle color="white" />
        </button>
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    const hasRecording = !!rowData.recording_file;

    const handleViewClick = async () => {
      if (!rowData.trace_id) {
        console.warn("Trace ID is missing");
        return;
      }

      const start = encodeURIComponent(rowData.start_time);
      const end = encodeURIComponent(rowData.end_time);
      const did = encodeURIComponent(rowData.callee_number);
      const trace_id = encodeURIComponent(rowData.trace_id);

      try {
        const response = await getApiCall(
          `${API_INCOMING_REPORT_BY_DID_LIST}/${did}/${start}/${end}/${trace_id}`
        );

        const incoming = response?.incomingReports || [];
        const outbound = response?.outboundReports || [];

        let main;
        let rest;

        if (userRole === USER_ROLES.CALL_CENTRE_AGENT) {
          main = outbound.find(d => d.id === rowData.id);
          rest = incoming
        } else {
          main = incoming.find(d => d.id === rowData.id);
          rest = outbound;
        }

        setMainCall(main);
        setRelatedCalls(outbound);
        setShowSidePanel(true);
      } catch (err) {
        console.log(err);
      }
    };

    return (
      <>
        <button
          className="btn-icons m-1"
          onClick={handleViewClick}
          style={{ border: "none", background: "none", padding: "0" }}
        >
          <i
            className="fa fa-eye"
            aria-hidden="true"
            style={{ color: "blue", fontSize: "18px" }}
          ></i>
        </button>


        {hasRecording ? (
          <>
            <button
              className="btn-icons m-1"
              onClick={() => handlePlayPause(rowData.id)}
              style={{ border: "none", background: "none", padding: "0", position:'relative' }}
            >
              {playingId === rowData.id ? (
                // Pause icon
                <svg width="25" height="25" viewBox="0 0 24 24" style={{ color: 'blue',position:'absolute', bottom:"-5.5px", left:"-4px" }}>
                  <path
                    d="M6 5h4v14H6zM14 5h4v14h-4z"
                    fill="currentColor"
                  />
                </svg>
              ) : (
                <svg width="25" height="25" viewBox="0 0 24 24" style={{ color: 'blue',position:'absolute', bottom:"-5.5px", left:"-4px" }}>
                  <path
                    d="M8 5v14l11-7z"
                    fill="currentColor"
                  />
                </svg>
              )}
            </button>
            <audio
              ref={(el) => (audioRefs.current[rowData.id] = el)}
              src={rowData.recording_file}
            />
          </>
        ) : (
          null
        )}
      </>
    );
  };

  const getDTMFValue = (mainCall, relatedCalls) => {
    const all = [
      mainCall,
      ...relatedCalls.filter(c => c.trace_id === mainCall.trace_id)
    ];

    const dtmfList = all
      .map(c => c.dtmf)
      .filter(Boolean);

    if (!dtmfList.length) return "";
    return dtmfList.sort((a, b) => b.length - a.length)[0];
  };

  const getValidDTMFSet = (mainCall, relatedCalls) => {
    const all = [
      mainCall,
      ...relatedCalls.filter(c => c.trace_id === mainCall.trace_id)
    ];

    const validList = all
      .map(c => c.valid_dtmf)
      .filter(Boolean);

    if (!validList.length) return new Set();
    const combined = validList.sort((a, b) => b.length - a.length)[0];
    return new Set(combined.split(",").filter(Boolean));
  };

  useEffect(() => {
    const fetchHangupCauses = async () => {
      try {
        const response = await getApiCall(API_HANGUP_CAUSES);
        const data = response?.data || response || [];
        const mapped = Object.fromEntries(
          data.map((item) => [
            item.hangup_cause_code,
            item.message || item.hangup_cause_reason || "Unknown",
          ])
        );

        setHangupCauseMap(mapped);
      } catch (err) {
        console.error("Failed to fetch hangup causes", err);
      }
    };

    fetchHangupCauses();
  }, []);


  return (
    <div>
      <div className="card" style={{ marginTop: "20px" }} >
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title m-0">DID Detail View</h4>
          <button
            className="btn btn-primary"
            onClick={() => navigate(`/${ROUTES.IVR.INCOMING_SUMMARY}`)}
            style={{ marginRight: '10px' }}
          >
            {userRole === USER_ROLES.CALL_CENTRE_AGENT ? "Back to Outbound Summary" : "Back to Incoming Summary"}
          </button>
        </div>
        <div className="card-body">
          <div className="d-flex align-items-center mb-3" style={{ marginLeft: "10px" }}>
            <Form.Control
              type="time"
              value={timeToInputStr(detailStartTime)}
              placeholder="Start Time"
              onChange={(e) => setDetailStartTime(inputStrToTimeDate(e.target.value))}
              style={{ width: "140px", flexShrink: 0 }}
            />
            <span className="mx-2">to</span>
            <Form.Control
              type="time"
              value={timeToInputStr(detailEndTime)}
              placeholder="End Time"
              onChange={(e) => setDetailEndTime(inputStrToTimeDate(e.target.value))}
              style={{ width: "140px", flexShrink: 0 }}
            />
            <Button
              label="Filter"
              onClick={handleDetailFilter}
              className="p-button-sm p-button-primary mx-2"
            />
            <Button
              label="Reset"
              onClick={handleDetailClearFilter}
              className="p-button-sm p-button-secondary"
            />
          </div>
          <div className="scroll-container">
            <DataTable value={incomingReport} paginator rows={10} tableStyle={{ minWidth: "50rem" }}>
              <Column field="user_id" header="User Id" />
              <Column field="caller_number" header="Caller Number" />
              <Column field="callee_number" header="Callee Number" />
              <Column field="start_time" header="Start Time" body={(rowData) => formatDateTime(rowData.start_time)} />
              <Column field="end_time" header="End Time" body={(rowData) => formatDateTime(rowData.end_time)} />
              <Column header="Trace ID" body={(rowData) => rowData.trace_id || "-"} />
              <Column header="Action" body={actionBodyTemplate} />
            </DataTable>
          </div>
        </div>
      </div>
      {/* <ToastNotification
            show_toast={showToast}
            set_show_toast={setShowToast}
            {...toastProps}
          />
          <Modal show={showToastModal} centered onHide={() => setShowToastModal(false)} size="sm">
            <Modal.Body className="text-center">
              <h5>{toastMessage}</h5>
              <LottieAnimation animationData={"https://assets6.lottiefiles.com/packages/lf20_touohxv0.json"} />
            </Modal.Body>
          </Modal> */}



      {showSidePanel && (
        <div
          
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: 'calc(100vw / var(--app-zoom, 1))',
            height: 'calc(100vh / var(--app-zoom, 1))',
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            backdropFilter: 'blur(2px)',
            zIndex: 1045,
          }}
          onClick={() => setShowSidePanel(false)}
        />
      )}

      <Dialog
        header="Call Events Details"
        visible={statusDialogVisible}
        onHide={() => setStatusDialogVisible(false)}
        style={{ width: "720px", maxWidth: "94vw" }}
        draggable={false}
        resizable={false}
      >
        {statusDialogCall ? (
          <div>
            {(() => {
              const connected = isConnected(statusDialogCall);
              const ringOk = hasRung(statusDialogCall);

              const okColor = "#16a34a";
              const badColor = "#dc2626";
              const lineColor = "#cbd5e1";

              const isIVR = statusDialogCall?.routing_type === "IVR";

              let parsedLifeCycle = [];
              try {
                parsedLifeCycle = statusDialogCall?.life_cycle
                  ? JSON.parse(statusDialogCall.life_cycle)
                  : [];
              } catch (e) {
                console.error("Invalid life_cycle JSON", e);
              }

              const steps = parsedLifeCycle.map((item, index) => {
                const eventName = item?.event || "Unknown Event";
                let title = eventName;
                let detail = "";
                let ok = true;
                switch (eventName) {
                  case "Call Initiated":
                    title = "Call Initiated";
                    detail = `Start: ${formatDateTime(item.time)}`;
                    ok = true;
                    break;

                  case "Call Ringing":
                    title = "Ring";
                    detail = `Ringing At: ${formatDateTime(item.time)}`;
                    ok = true;
                    break;

                  case "Remote End Ringing":
                    title = "Remote End Ringing";
                    detail = `Remote Ringing At: ${formatDateTime(item.time)}`;
                    ok = true;
                    break;

                  case "Call Connected":
                    title = isIVR ? "Connected in IVR" : "Connected";
                    detail = `Connected At: ${formatDateTime(item.time)}`;
                    ok = true;
                    break;

                  case "Remote End Answered":
                    title = "Remote End Answered";
                    detail = `Remote Answered At: ${formatDateTime(item.time)}`;
                    ok = true;
                    break;

                  case "Dtmf Recieved":
                    title = "DTMF Received";
                    detail = `Digit: ${item?.data?.Digit || "-"} • Status: ${
                      item?.data?.Status || "-"
                    } • Level: ${item?.data?.Level || "-"}`;
                    ok = item?.data?.Status === "VALID";
                    break;

                  case "Call Hungup":
                    title = "Hangup";
                    detail = `End: ${formatDateTime(item.time)}`;
                    ok = true;
                    break;

                  default:
                    detail = formatDateTime(item.time);
                    ok = true;
                }

                return {
                  key: `${eventName}-${index}`,
                  title,
                  ok,
                  detail,
                };
              });

              return (
                <>
                  <div
                    style={{
                      padding: "12px 14px",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      background: "#ffffff",
                      marginBottom: "14px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "12px" }}>
                      <div>
                        <div style={{ fontWeight: 800, fontSize: "14px" }}>
                          {statusDialogCall.caller_number || "-"} → {statusDialogCall.callee_number || "-"}
                        </div>
                        <div style={{ fontSize: "12px", marginTop: "2px" }}>
                          Call SID: {statusDialogCall.call_sid || "-"} • Trace ID: {statusDialogCall.trace_id || "-"}
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: 800,
                          padding: "6px 12px",
                          borderRadius: "999px",
                          background: connected ? "rgba(22,163,74,0.10)" : "rgba(220,38,38,0.10)",
                          color: connected ? okColor : badColor,
                          border: `1px solid ${connected ? "rgba(22,163,74,0.20)" : "rgba(220,38,38,0.20)"}`,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {connected ? "Connected" : "Failed"}
                      </div>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginTop: "12px" }}>
                      <div style={{ fontSize: "12px" }}>
                        <div style={{ fontWeight: 800 }}>Start</div>
                        <div>{formatDateTime(statusDialogCall.start_time)}</div>
                      </div>
                      <div style={{ fontSize: "12px"  }}>
                        <div style={{ fontWeight: 800 }}>End</div>
                        <div>{formatDateTime(statusDialogCall.end_time)}</div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      padding: "14px",
                      borderRadius: "12px",
                    }}
                  >
                    <div style={{ fontWeight: 900, marginBottom: "12px" }}>
                      Event Timeline
                    </div>

                    {steps.map((step, index) => {
                      const color = step.ok ? okColor : badColor;
                      return (
                        <div key={step.key} style={{ display: "flex", gap: "12px" }}>
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <div
                              style={{
                                width: "14px",
                                height: "14px",
                                borderRadius: "999px",
                                background: color,
                                boxShadow: "0 0 0 4px rgba(2,6,23,0.04)",
                              }}
                            />
                            {index < steps.length - 1 ? (
                              <div style={{ width: "2px", flex: 1, background: lineColor, marginTop: "6px" }} />
                            ) : null}
                          </div>

                          <div style={{ paddingBottom: index < steps.length - 1 ? "16px" : 0, width: "100%" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
                              <div style={{ fontWeight: 900 }}>{step.title}</div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 900,
                                  padding: "4px 10px",
                                  borderRadius: "999px",
                                  background: step.ok ? "rgba(22,163,74,0.10)" : "rgba(220,38,38,0.10)",
                                  color: step.ok ? okColor : badColor,
                                  border: `1px solid ${step.ok ? "rgba(22,163,74,0.20)" : "rgba(220,38,38,0.20)"}`,
                                }}
                              >
                                {step.ok ? "OK" : "FAILED"}
                              </div>
                            </div>
                            <div style={{ marginTop: "4px", fontSize: "12px" }}>{step.detail}</div>
                          </div>
                        </div>
                      );
                    })}

                    {/* <div
                      style={{
                        marginTop: "10px",
                        paddingTop: "10px",
                        borderTop: "1px dashed #e2e8f0",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "10px",
                      }}
                    >
                      <div style={{ fontSize: "12px", color: "#475569" }}>
                        <div style={{ fontWeight: 900, color: "#0f172a" }}>patch_duration</div>
                        <div>{toNum(statusDialogCall.patch_duration)} sec</div>
                      </div>
                      <div style={{ fontSize: "12px", color: "#475569" }}>
                        <div style={{ fontWeight: 900, color: "#0f172a" }}>hangup_cause</div>
                        <div>{statusDialogCall.hangup_cause || "-"}</div>
                      </div>
                    </div> */}
                  </div>
                </>
              );
            })()}
          </div>
        ) : null}
      </Dialog>

      <div
        className="custom-scrollbar-panel"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: showSidePanel ? 'translate(-50%, -50%)' : 'translate(-50%, -150%)',
          transition: 'transform 0.3s ease-in-out',
          zIndex: 1050,
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
          width: '70%',
          maxHeight: '70%',
          overflowY: 'auto',
          padding: '20px',
          display: showSidePanel ? 'block' : 'none',
        }}
      >

        {showSidePanel && (mainCall || relatedCalls.length > 0) && (
          <>
            {/* FIXED CALL INFO SECTION */}

            <div  >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h5>Call Information</h5>
                <button
                  onClick={() => setShowSidePanel(false)}
                  style={{
                    border: 'none',
                    background: 'transparent !important',
                    borderRadius: '4px',
                    padding: '4px 8px',
                  }}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>

              {mainCall && (
                <div style={{ marginBottom: '20px', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
                  <h3>{mainCall.callee_number}</h3>
                  <div style={{ display: 'flex', gap: '60px', marginTop: '20px' }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <p>Call Sid:</p>
                      <p>Trace ID:</p>
                      {mainCall.routing_type &&
                      <p>Routing Type:</p>}
                      <p>Start Date:</p>
                      <p>End Date:</p>
                      <p>Caller Number:</p>
                      {/* <p>Agent Name:</p>
              <p>Agent Number:</p> */}
                      {/* <p>Call Group Name:</p> */}
                      <p>Answer Status:</p>
                      <p>Recording:</p>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <p>{mainCall.call_sid}</p>
                      <p>{mainCall.trace_id}</p>
                      {mainCall.routing_type &&
                      <p>
                        {mainCall.routing_type}{" "}
                        {mainCall.routing_type === "IVR"
                          ? mainCall.ivr_name
                          : mainCall.routing_type === "AGENT"
                          ? relatedCalls.find(c => c.trace_id === mainCall.trace_id)?.agent_name || "-"
                          : ""}
                      </p>}
                      <p>{formatDateTime(mainCall.start_time)}</p>
                      <p>{formatDateTime(mainCall.end_time)}</p>
                      <p>{mainCall.caller_number}</p>
                      {/* <p>{mainCall.agent_name}</p>
              <p>{mainCall.agent_number}</p> */}
                      {/* <p>{mainCall.queue_name}</p> */}
                      {/* <p>{mainCall.queue_name}</p> */}
                      <div>{statusPill(mainCall)}</div>
                     {(() => {
  const recordings = getRecordingData(mainCall.recording_file);

  return recordings.length ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginTop: "10px"
      }}
    >
      {recordings.map((rec, index) => (
        <div
          key={index}
          style={{
            border: "1px solid #dddddd33",
            borderRadius: "8px",
            padding: "10px",
          }}
        >
          <audio
            controls
            style={{ width: "100%", height: "35px" }}
          >
            <source src={rec.url} type="audio/wav" />
          </audio>

          <div
            style={{
              marginTop: "8px",
              fontSize: "12px",
              display: "grid",
              gridTemplateColumns: "120px auto",
              gap: "4px"
            }}
          >
            <b>Name:</b> <span>{rec.name}</span>
            <b>Duration:</b> <span>{rec.duration ?? 0} sec</span>
            <b>Status:</b> <span>{rec.status}</span>
            <b>Start:</b> <span>{formatDateTime(rec.startTime)}</span>
            <b>End:</b> <span>{formatDateTime(rec.endTime)}</span>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <p style={{ marginTop: "10px" }}>Not Available</p>
  );
})()}
                    </div>
                    {mainCall.routing_type === "IVR" && (() => {
                      const dtmfValue = getDTMFValue(mainCall, relatedCalls);
                      const validSet = getValidDTMFSet(mainCall, relatedCalls);
                      const digits = dtmfValue.split(",").filter(Boolean);

                      if (!digits.length) return null;

                      return (
                        <div style={{ marginTop: "6px" }}>
                          <div style={{ fontSize: "12px", fontWeight: 700 }}>
                            DTMF Journey
                          </div>

                          <div style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "6px",
                            marginTop: "4px"
                          }}>
                            {digits.map((digit, index) => {
                              const isLast = index === digits.length - 1;
                              const isValid = validSet.has(digit);
                              return (
                                <React.Fragment key={index}>
                                  <div
                                    style={{
                                      minWidth: "28px",
                                      height: "28px",
                                      borderRadius: "8px",
                                      background: isValid
                                        ? "#16a34a"
                                        : "#b40000",
                                      color: "#ffffff",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontWeight: 800,
                                      fontSize: "12px",
                                      boxShadow: isValid
                                        ? "0 3px 8px rgba(22,163,74,0.4)"
                                        : isLast
                                        ? "0 3px 8px rgba(37,99,235,0.4)"
                                        : "none"
                                    }}
                                  >
                                    {digit}
                                  </div>

                                  {index < digits.length - 1 && (
                                    <span style={{ fontSize: "12px", color: "#94a3b8" }}>
                                      →
                                    </span>
                                  )}
                                </React.Fragment>
                              );
                            })}
                        </div>
                      </div>
                    );
                    })()}
                  </div>
                </div>
              )}
            </div>



            <div >
              <div style={{ display: "flex", gap: "50px", padding: "10px" }}>
                <h5 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <PhoneIncoming size={18} color="green" strokeWidth={2.5} />
                  Incoming Call
                </h5>
                <h5 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <PhoneOutgoing size={18} color="blue" strokeWidth={2.5} />
                  Outbound Call
                </h5>
              </div>

              {showSidePanel && (
                <div style={{ marginTop: '20px', overflow: "auto", }} className="my-data-table" >
                  <DataTable
                    value={[mainCall, ...relatedCalls.filter(c => c.trace_id === mainCall.trace_id)]}
                    tableStyle={{ minWidth: "100rem" }}
                  >
                    <Column
                      header=""
                      body={(rowData) =>
                        rowData.call_sid === mainCall.call_sid ? (
                          <PhoneIncoming size={18} color="green" strokeWidth={2.5} />
                        ) : (
                          <PhoneOutgoing size={18} color="blue" strokeWidth={2.5} />
                        )
                      }
                      style={{ width: '3rem' }}
                    />
                    <Column field="call_sid" header="Call SID" />
                    <Column field="caller_number" header="Caller Number" />
                    <Column field="callee_number" header="Callee Number" />
                    <Column
                      header="Answer Status"
                      body={(row) => statusPill(row)}
                    />
                    <Column field="start_time" header="Start Time" body={(row) => formatDateTime(row.start_time)} />
                    <Column field="end_time" header="End Time" body={(row) => formatDateTime(row.end_time)} />
                    <Column field="billing_duration" header="Billing Duration" />
                    <Column field="patch_duration" header="Patch Duration" />
                    <Column
                      header="Hangup Cause"
                      body={(rowData) => {
                        const cause = rowData.hangup_cause;
                        const label = hangupCauseMap[cause] || `Unknown`;
                        const isSuccess = cause == 16;
                        return (
                          <span style={{ color: isSuccess ? "green" : "red" }}>
                            {label}
                          </span>
                        );
                      }}
                    />
                    {/* <Column field="bridge_ring_duration" header="Ring Duration" /> */}
                  </DataTable>
                </div>
              )}
            </div>


            {/* RELATED CALLS TABLE WRAPPER */}

            <div style={{ overflow: "auto" }} className="my-data-table" >
              {relatedCalls.length > 0 && (
                <>
                  <h5 style={{ marginTop: '30px', marginLeft: "10px" }}>Related Calls</h5>
                  <div
                    style={{
                      marginTop: '20px',
                      width: '100%',
                      paddingBottom: '10px',
                    }}
                  >
                    <DataTable value={relatedCalls} paginator rows={5} tableStyle={{ minWidth: '1500px' }}>
                      <Column field="call_sid" header="Call SID" />
                      <Column field="caller_number" header="Caller Number" />
                      <Column field="agent_name" header="Agent Name" />
                      <Column field="agent_number" header="Agent Number" />
                      <Column
                        field="start_time"
                        header="Start Time"
                        body={(row) => formatDateTime(row.start_time)}
                      />
                      <Column
                        field="end_time"
                        header="End Time"
                        body={(row) => formatDateTime(row.end_time)}
                      />
                      <Column
                        header="Answer Status"
                        body={(row) => statusPill(row)}
                      />
                      <Column field="patch_duration" header="Patch Duration (sec)" />
                      <Column field="billing_duration" header="Billing Duration (sec)" />
                      <Column field="total_hold_duration" header="Hold Duration (sec)" />
                      <Column
                        header="Hangup Cause"
                        body={(rowData) => {
                          const cause = rowData.hangup_cause;
                          const label = hangupCauseMap[cause] || `Unknown`;
                          const isSuccess = cause == 16;
                          return (
                            <span style={{ color: isSuccess ? "green" : "red" }}>
                              {label}
                            </span>
                          );
                        }}
                      />
                      <Column
  header="Recording"
  body={(row) => {
    const recordings = getRecordingData(row.recording_file);

    if (!recordings.length) return "-";

    return (
      <div
        style={{
          display:"flex",
          flexDirection:"column",
          gap:"8px"
        }}
      >
        {recordings.map((rec,index)=>(
          <div key={index}>
            <audio controls style={{ height: "30px" }}>
              <source src={rec.url} type="audio/wav" />
            </audio>

            <div
              style={{
                fontSize:"11px",
                marginTop:"3px"
              }}
            >
              {rec.status}
            </div>
          </div>
        ))}
      </div>
    );
  }}
/>
                    </DataTable>


                  </div>
                </>
              )}
            </div>

          </>
        )}



      </div>




    </div>
  );
};

export default DidDetailPage;
